<template>
  <box-wrapper :focus="focus" :is-clickable="isClickable" class="w-full">
    <template #text>
      <div class="my-auto break-words overflow-hidden leading-relaxed" v-html="truncatedCustomerInput" />
    </template>
    <template #footer>
      <slot name="footer"/>
    </template>
  </box-wrapper>
</template>

<script>
import BoxWrapper from '@/components/base-components/BoxWrapper'

export default {
  name: 'CustomerBubble',

  components: { BoxWrapper },

  props: {
    customerInput: {
      required: true,
      type: [String, Object]
    },
    focus: {
      default: false,
      type: Boolean
    },
    isClickable: {
      default: false,
      type: Boolean
    }
  },

  computed: {
    truncatedCustomerInput() {
      const stripWhitespace = (str) => str.replace(/\n/g, '').replace(/\s+/g, ' ').trim()
      const truncateResult = (str) => str.length > 200 ? str.substring(0, 200) + '…' : str

      if (typeof this.customerInput === 'string') {
        if (this.customerInput.includes('context-substituted') || this.customerInput.includes('div')) {
          const strippedHTMLTagsText = stripWhitespace(this.stripHtmlTags(this.customerInput))
          return truncateResult(strippedHTMLTagsText)
        }

        const strippedText = stripWhitespace(this.customerInput)
        return truncateResult(strippedText)
      }

      return this.customerInput
    }
  },

  mounted() {
    this.setupContextTooltipListeners()
  },

  beforeDestroy() {
    this.removeContextTooltipListeners()
  },

  updated() {
    this.removeContextTooltipListeners()
    this.setupContextTooltipListeners()
  },

  methods: {
    setupContextTooltipListeners() {
      this.$nextTick(() => {
        const contextElements = this.$el.querySelectorAll('.context-substituted')
        contextElements.forEach(element => {
          element.addEventListener('mouseenter', this.handleContextMouseEnter)
          element.addEventListener('mouseleave', this.handleContextMouseLeave)
        })
      })
    },

    removeContextTooltipListeners() {
      const contextElements = this.$el.querySelectorAll('.context-substituted')
      contextElements.forEach(element => {
        element.removeEventListener('mouseenter', this.handleContextMouseEnter)
        element.removeEventListener('mouseleave', this.handleContextMouseLeave)
      })
    },

    handleContextMouseEnter(event) {
      const contextKey = event.target.getAttribute('data-context')
      if (contextKey) {
        this.$emit('context-tooltip-show', contextKey)
      }
    },

    handleContextMouseLeave(event) {
      this.$emit('context-tooltip-hide')
    }
  }
}
</script>

<style lang="scss">
.context-substituted {
  text-decoration: underline;
  text-decoration-style: dotted;
}
</style>
